import matrixDataAr from "../other/matrix-data-ar";

const materialsPageDataAr = {
    mainTitle : "القضايا الجوهرية بالنسبة لبنك الأول",
    sectionOne : {
        // subtitle : "To determine our material matters, we followed a robust process of analysis and Stakeholder engagement that incorporated both quantitative and qualitative elements.",
        borderLeftBox : {
            title : "قضايا الممارسات البيئية والاجتماعية والحوكمة المؤسسية الأكثر أهمية بالنسبة لبنك الأول",
            subtitle : 'يسعى البنك إلى المساهمة بفعالية في تحقيق مستهدفات رؤية السعودية 2030، ويهدف دومًا لأن يكون "المواطن الصالح". وتحقيقًا لذلك، وجب على البنك المشاركة مع أصحاب المصلحة الرئيسيين واستيعاب القضايا الحرجة المطروحة، ودمج جميع الجوانب الجوهرية ضمن استراتيجيتنا.',
        },
        borderLeftBoxTwo : {
            title : "عملية تحديد الأهمية النسبية لبنك الأول",
            subtitle : 'بهدف تحديد القضايا الجوهرية بالنسبة للبنك، اتبعنا عملية تحليل قوية ومشاركة أصحاب المصلحة بناء على العناصر الكمية والنوعية.',
        },
        // paragraph : "To determine our material matters, we followed a robust process of analysis and Stakeholder engagement that incorporated both quantitative and qualitative elements.",
        cards : [
            {
                icon : {
                    name : "understand.svg",
                    alt : "",
                },
                title : "الفهم",
                subtitle : "يحافظ بنك الأول على قنوات اتصال ثنائية الجانب مع أصحاب المصلحة الرئيسيين، كما هو موضح في الصفحة 28 من هذا التقرير. ويراقب، في الوقت ذاته، تطورات السوق ليتكون لديه فهم عميق للسياق التشغيلي للبنك.",
            },
            {
                icon : {
                    name : "identify.svg",
                    alt : "",
                },
                title : "التحديد",
                subtitle : "انطلاقًا من الفهم العميق لسياقه، أجرى بنك الأول استطلاعًا بمساعدة شركة من خارج البنك بالتعاون مع مجموعة العمل المعنية بالممارسات البيئية والاجتماعية والحوكمة المؤسسية في البنك، وأعقب ذلك ورشة عمل لتحديد مجموعة القضايا الجوهرية المحتملة التي تؤثر على بنك الأول وأصحاب المصلحة فيه. وقد أثرت المقابلات مع بعض المديرين التنفيذيين في بنك الأول، بما في ذلك الرئيس التنفيذي والمدير المالي، في تحديد القضايا المهمة التي تم تقديمها أخيرًا إلى اللجنة التوجيهية للممارسات البيئية والاجتماعية والحوكمة المؤسسية في البنك للمناقشة والتأكيد.",
            },
            {
                icon : {
                    name : "assess.svg",
                    alt : "",
                },
                title : "التقييم",
                subtitle : "بمجرد تحديد قائمة شاملة بالقضايا المهمة، أجرى بنك الأول استطلاعًا للأهمية بمساعدة شركة من خارج البنك مع أصحاب المصلحة من داخل البنك وخارجه - ومنهم العملاء وشركاء الأعمال والموردين - لتقييم ما أهمية هذه القضايا بالنسبة لهم.",
            },
            {
                icon : {
                    name : "prioritise.svg",
                    alt : "",
                },
                title : "الأولويات",
                subtitle : "وبعد تحليل متعمق لنتائج الاستطلاع، وضع بنك الأول مصفوفة الأهمية التي تسلط الضوء على قضايا الأهمية النسبية التي يواجهها البنك وأصحاب المصلحة.",
            },
        ]
    },
    sectionTwo : {
        title : "مصفوفة الأهمية النسبية لبنك الأول",
        sutitle : 'كما هو موضح في شبكة مصفوفة الأهمية النسبية التالية، تشمل القضايا البيئية التي تحظى بالأهمية النسبية لبنك الأول: التمويل والانبعاثات والمياه والنفايات وتأثيرات التنوع البيولوجي. وتتمحور هذه القضايا الجوهرية حول البعد الاجتماعي المجتمعات المحلية، والتنوع، والتوظيف، وحماية خصوصية العملاء، والجوانب الاجتماعية لموردينا، والتدريب والتعليم، والصحة والسلامة المهنية. وتغطي القضايا الاقتصادية الجوهرية الأداء الاقتصادي والآثار الاقتصادية غير المباشرة وممارسات المشتريات، بينما تشمل قضايا الحوكمة الالتزام برؤية السعودية 2030 وأخلاقيات وأطر الحوكمة.',
        image : {
            src : "matrix-one.jpg",
            alt : "SAB’s materiality matrix plan",
        },
        matrixData : {
            matrix : matrixDataAr,
            xAxis : {
                label : "الأهمية بالنسبة لبنك الأول",
            },
            yAxis : {
                label : "الأهمية بالنسبة لأصحاب المصلحة الخارجيين"
            },
            levels : ["منخفض", "متوسط", "مرتفع"],
            keys : [
                {
                    icon : "environment.svg",
                    text : "الجوانب البيئية"
                },
                {
                    icon : "economic.svg",
                    text : "الجوانب الاقتصادية"
                },
                {
                    icon : "social.svg",
                    text : "الجوانب الاجتماعية"
                },
                {
                    icon : "governance.svg",
                    text : "الحوكمة المؤسسية"
                },
            ]
        },
        tabsView : {
            title : "القضايا الجوهرية لبنك الأول",
            tabs : {
                headers : ["مرتفع", "متوسط", "منخفض"],
                tableHeaders : ["القضايا الجوهرية", "الموضوع الاستراتيجي", "الوصف", "التقرير"],
                elements : [
                    [
                        {
                            title : "الالتزام برؤية المملكة 2030",
                            icon : "hand-shack.svg",
                            description : 'تحقيقًا لهدفه المتمثل في أن يكون "المواطن الصالح"، يقوم بنك الأول بمواءمة استراتيجيته التجارية واستراتيجيته للممارسات البيئية والاجتماعية والحوكمة المؤسسية مع مبادئ وأهداف رؤية السعودية 2030."',
                            page : "الصفحة 46",
                        },
                        {
                            title : "الأداء الاقتصادي",
                            icon : "hand-leaves-blue.svg",
                            description : "يعتمد بنك الأول ومعظم المؤسسات والشركات على تحقيق عوائد وأرباح في سبيل المحافظة على استدامة الأعمال. وسرعان ما سيصبح بنك الأول غير مستداماً إذا ما واجه صعوبات في مواصلة تحقيق أداء مالي جيد.",
                            page : "الصفحة 25",
                        },
                        {
                            title : "الأخلاقيات",
                            icon : "hand-shack.svg",
                            description : "تشكل الممارسات الأخلاقية والسلوكية الأسس الذي تبنى عليها الحوكمة السليمة للشركات، وتساهم في منع الاحتيال والفساد.",
                            page : "الصفحة 124",
                        },
                        {
                            title : "المجتمعات المحلية",
                            icon : "runners.svg",
                            description : "تعد مجتمعات المملكة جزءً أساسيًا ضمن عمليات بنك الأول، كما تمثل كفاءتنا المصرفية ضرورة لمواصلة رعايتهم. ويمثل الحفاظ على علاقات متينة مع مجتمعاتنا ودعمهم عندما نستطيع ذلك أولوية قصوى بالنسبة للبنك.",
                            page : "الصفحة 86",
                        },
                        {
                            title : "التمويل المستدام",
                            icon : "hand-leaves-blue.svg",
                            description : 'تتمثل أكبر مساهمات بنك الأول في تحقيق رؤية السعودية 2030 والتخفيف من آثار تغير المناخ في توفير تمويل بمزايا جذابة للمشاريع والخدمات "الخضراء". ونتيجة لذلك، يعمل بنك الأول على تكثيف استثماراته في المشاريع الخضراء بشكل كبير على مدى السنوات الـ 3 القادمة.',
                            page : "الصفحة 54",
                        },
                        {
                            title : "حماية خصوصية العملاء",
                            icon : "runners.svg",
                            description : 'أصبحت الجرائم الإلكترونية و"القرصنة" أكثر انتشارًا وتطورًا. يتعين على بنك الأول، إلى جانب معظم المؤسسات في أنحاء العالم، التأكد من قوة أنظمة الأمن الرقمي لديها بما يمنع حدوث أي تسريب لبيانات العملاء.',
                            page : "الصفحة 82",
                        },
                        {
                            title : "التوظيف",
                            icon : "runners.svg",
                            description : "غالبًا ما تسبب البطاقة تهميش الأشخاص العاطلين عن العمل من المشاركة الفاعلة في الحياة الاجتماعية. يعالج بنك الأول هذه القضية الجوهرية من خلال مجموعة من البرامج التي تمكّن المواطنين من الحصول على عمل وتطوير مهاراتهم ومتابعة التعليم العالي.",
                            page : "الصفحة 82",
                        },
                        {
                            title : "التنوع",
                            icon : "runners-green.svg",
                            description : "أظهرت الدول التي تتمتع بمعدلات تنوع أعلى قدرة فائقة على الإنتاجية. يبذل بنك الأول جهودًا حثيثة لزيادة مستويات التنوع ضمن فريقه بهدف تحقيق الاستفادة القصوى من المواهب الموجودة ضمن كافة شرائح مجتمعنا.",
                            page : "الصفحة 74",
                        },
                        {
                            title : "إطار الحوكمة",
                            icon : "hand-shack.svg",
                            description : "تستند الحوكمة الناجحة للشركات على تطبيق أفضل السياسات والإجراءات لضمان العمل بكفاءة وفعالية. يعمل بنك الأول على إنشاء إطار عمل وعمليات تتوافق مع أفضل الممارسات.",
                            page : "الصفحة 104",
                        },
                        {
                            title : "الانبعاثات",
                            icon : "leave-elct.svg",
                            description : "تُعد الانبعاثات التي ينتجها النشاط البشري في الغلاف الجوي للأرض العامل الأكثر تأثيرًا في ظاهرة الاحتباس الحراري. وضع بنك الأول ضمن أولوياته خفض انبعاثاته للوصول إلى الحياد الكربوني، ويلتزم البنك بإجراء مراجعة لانبعاثات محفظته تمويلاته خلال العام 2023.",
                            page : "الصفحة 62",
                        },
                        {
                            title : "استهلاك المياه",
                            icon : "leave-elct.svg",
                            description : "تُعد المملكة من البلدان ذات الموارد المائية الشحيحة، وقد تواجه ظروف زيادة الجفاف ودرجات الحرارة نتيجة لتأثيرات تغير المناخ. صُمم المقر الرئيسي الجديد لبنك الأول ومبادرات البنك لتوفير المياه أو إعادة تدويرها بهدف تقليل استهلاكنا للمياه.",
                            page : "الصفحة 65",
                        },
                    ],
                    [
                        {
                            title : "الآثار الاقتصادية غير المباشرة ",
                            icon : "hand-leaves.svg",
                            description : "يساهم توفير التمويل المستدام ودعم مشاريع، مثل مبادرة السعودية الخضراء، في مضاعفة أثرها الإيجابي وتحقق مكاسب اقتصادية كبيرة.",
                            page : "الصفحة 54",
                        },
                        {
                            title : "إدارة المخلفات",
                            icon : "leave-elct.svg",
                            description : "ما تزال النفايات الناتجة عن العمليات أمراً لا بد منه، على الرغم من التقدم الملحوظ الذي أحرزه بنك الأول في الحد من استخدام الورق وإعادة تدوير المخلفات التي يُنتجها.",
                            page : "الصفحة 64",
                        },
                        {
                            title : "التدريب والتعليم",
                            icon : "target.svg",
                            description : "السكان المثقفون يسهمون بفعالية في إنتاجية المجتمع. يولي بنك الأول اهتماماً كبيراً لرفع عدد الأفراد المتعلمين والمنتجين من خلال تنفيذ برامج تدريبية داخلية للموظفين وبرامج توعية مالية خارجية متاحة لمواطني المملكة.",
                            page : "الصفحة 92",
                        },
                        {
                            title : "الصحة والسلامة المهنية",
                            icon : "runners.svg",
                            description : 'يتعرض الموظفون لضغوط أكثر من قبل بعد تفشي جائحة فيروس كورونا المستجد "كوفيد-19". وقد أطلق بنك الأول مبادرات لضمان سلامة الموظفين في مكان العمل.',
                            page : "الصفحة 114",
                        },
                    ],
                    [
                        {
                            title : "تأثيرات التنوع البيولوجي",
                            icon : "trees.svg",
                            description : "على الرغم من التأثيرات المباشرة الضئيلة لعمليات بنك الأول على التنوع البيولوجي في المملكة، إلا أن البنك يساهم في دعم التنوع البيولوجي المحلي من خلال الجهود التي يبذلها في زراعة الأشجار ضمن مبادرة السعودية الخضراء.",
                            page : "الصفحة 66",
                        },
                        {
                            title : "التقييم الاجتماعي للموردين",
                            icon : "runners.svg",
                            description : "يتعهد بنك الأول بمسؤوليته في ضمان أن يكون الموردين مطلعين بشكل كامل على معايير الممارسات البيئية والاجتماعية والحوكمة المؤسسية ومعرفتهم بها، وبأنهم لن يقفوا عائقًا أمام تحقيق أهدافنا المتعلقة بالممارسات البيئية والاجتماعية والحوكمة المؤسسية. قمنا بتحديث متطلبات تسجيل الموردين الخاصة بالبنك لدمج عوامل الممارسات البيئية والاجتماعية والحوكمة المؤسسية في عملية تقييم الموردين الجدد.",
                            page : "الصفحة 34",
                        },
                        {
                            title : "ممارسات المشتريات",
                            icon : "hand-shack.svg",
                            description : "اتخذ البنك قرارًا حاسمًا بالشراء من الموردين الذين يتوافقون مع أخلاقيات البنك وبرامج الممارسات البيئية والاجتماعية والحوكمة المؤسسية الخاصة بالبنك.",
                            page : "الصفحة 34",
                        },
                    ],
                    
                ]
            }
        },
        tableTabs : {

            title : "SAB’s material issues",
            
            
        },
        borderLeftBox : {
            title : "الأهمية النسبية المستمرة",
            subtitle : "نسرد في هذا القسم نتائج أول عملية لتقييم الأمور المهمة بالنسبة لبنك الأول. سيواصل بنك الأول مشاركة القضايا ذات الأهمية مع أصحاب المصلحة بالتزامن مع مسيرته المستمرة في ممارسات الحوكة البيئية والاجتماعية والمؤسسية. ولا شك أن الجوانب الجوهرية ستتغير بمرور الوقت تبعًا لتغير ظروفنا التشغيلية. ومع تطور الحوار الداخلي للبنك، سنستخدم هذه المعلومات لتعزيز نهجنا في الممارسات البيئية والاجتماعية والحوكمة المؤسسية، وتحسين التواصل مع أصحاب المصلحة.",
        }
    }
};

export default materialsPageDataAr;